import type { RealtimeEvent } from "@/shared/api/generated/events";

import type { RealtimeEventType, RealtimeHandler, RealtimeHandlerContext } from "./RealtimeHandler";

type AnyHandler = (event: RealtimeEvent, context: RealtimeHandlerContext) => void;

// Реестр обработчиков по `type` события. На один тип можно повесить несколько
// обработчиков (разные фичи). Ошибка одного не мешает остальным.
export class RealtimeHandlerRegistry {
  readonly #handlers = new Map<RealtimeEventType, Set<AnyHandler>>();

  // Возвращает функцию отписки.
  register<T extends RealtimeEventType>(type: T, handler: RealtimeHandler<T>): () => void {
    const handlers = this.#handlers.get(type) ?? new Set<AnyHandler>();
    this.#handlers.set(type, handlers);
    // Безопасно: dispatch вызывает обработчик только для событий его типа.
    const anyHandler = handler as AnyHandler;
    handlers.add(anyHandler);
    return () => {
      handlers.delete(anyHandler);
    };
  }

  dispatch(event: RealtimeEvent, context: RealtimeHandlerContext): void {
    const handlers = this.#handlers.get(event.type);
    if (handlers === undefined) {
      return;
    }
    for (const handler of [...handlers]) {
      try {
        handler(event, context);
      } catch (error) {
        console.error("realtime handler failed", event.type, error);
      }
    }
  }
}
